import {Moment} from "moment";
import {Vnode} from "mithril";
import m from "mithril";
import DatePicker from "./DatePicker";

/**
 * One read only box of datepicker
 *
 * |----------|
 * |          |
 * |          |
 * |    ##    |  <-- Current value
 * |          |
 * |          |
 * |----------|
 *
 *
 */
export default class DateTimeReadOnlyBox {

    constructor(
        private readonly datepicker: DatePicker,
        private readonly dateFormatCallback: (date: Moment|null) => string,
    ) { }

    public get date() {
        return this.datepicker.date;
    }

    //------------------------._.-^
    // VIEW
    //
    public view(): Vnode {

        return m('.date-box.read-only', {}, [
            m('.box-top',{}),
            m('.box-middle',{}, this.dateFormatCallback(this.date)),
            m('.box-bottom',{}),
        ])

    }
}